const searchButtons = document.querySelectorAll('[data-nav-search-button]');
const searchForm = document.getElementById('header-search-form-container');
let searchFormToggled = false;

searchButtons.forEach((element, index, elements) => {
    element.addEventListener("keydown", (event) => handleButtonKey(event, element, index, elements));
    if (element.tagName === "BUTTON") {
        element.addEventListener("click", () => toggleSearchForm(element));
    }
});

// Sluit zoekformulier bij esc button
document.body.addEventListener('keydown', function(e) {
    if (e.key == "Escape" && searchFormToggled === true) {
        
        for (var i = 0; i < searchButtons.length; ++i) {
            searchButtons[i].setAttribute("aria-expanded", "false");
        }

        searchForm.setAttribute("aria-hidden", "true");
        searchForm.classList.remove("open");
    }
});


// key events voor zoekformulier
function handleButtonKey(event, element, index, elements) {
    const key = event.key;

    switch (key) {
        case "Enter":
        case " ":
            if (element.tagName === "BUTTON") {
                event.preventDefault();
                toggleSearchForm(element);
            }
            break;
    }
}


// Zoekformulier toggle logica
function toggleSearchForm(button) {
    
    //sluit het mobile menu eerst
    const menuIconID = document.getElementById('nav-menu-icon');
    const MenuID = document.getElementById('nav-mobile-menu');

    if(menuIconID.getAttribute('aria-expanded')=== "true") {
        menuIconID.setAttribute("aria-expanded", "false");
        menuIconID.classList.remove("close");

        MenuID.setAttribute("aria-hidden", "true");
        MenuID.classList.remove("open");
    }

    const searchFormId = button.getAttribute("aria-controls");
    const searchForm = document.getElementById(searchFormId);
    const isExpanded = button.getAttribute("aria-expanded") === "true";

    for (var i = 0; i < searchButtons.length; ++i) {
        if (isExpanded) {
            searchButtons[i].setAttribute("aria-expanded", "false");
        } else {
            searchButtons[i].setAttribute("aria-expanded", "true");
        }
    }

    if (isExpanded) {
        // Sluit het zoekformulier
        searchForm.setAttribute("aria-hidden", "true");
        searchForm.classList.remove("open");
        searchFormToggled = false;
    } else {
        // Open het zoekformulier
        searchForm.setAttribute("aria-hidden", "false");
        searchForm.classList.add("open");
        searchFormToggled = true;
    }

    // Focus op het eerste veld
    const firstField = searchForm.querySelector("input[type='text']");
    if (firstField) {
        firstField.focus();
    }
}
